<template>
  <path
    d="M3.5 8L12.5 8M3.5 4.5L12.5 4.5M3.5 11.5H9.5"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</template>
